import { load } from '@fingerprintjs/fingerprintjs';

const fpPromise = load();

async function getLocalIp() {
  return new Promise((resolve) => {
    try {
      const pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel('');
      const timer = setTimeout(() => { pc.close(); resolve(null); }, 1000);
      pc.createOffer()
        .then(offer => pc.setLocalDescription(offer))
        .catch(() => { clearTimeout(timer); pc.close(); resolve(null); });
      pc.onicecandidate = (e) => {
        if (!e || !e.candidate) return;
        const match = e.candidate.candidate.match(/(\d{1,3}(\.\d{1,3}){3})/);
        if (match) {
          clearTimeout(timer);
          pc.close();
          resolve(match[1]);
        }
      };
    } catch {
      resolve(null);
    }
  });
}

export async function getDeviceFingerprint() {
  try {
    const fp = await fpPromise;
    const [result, local_ip] = await Promise.all([fp.get(), getLocalIp()]);
    const components = result.components ? { ...result.components, _local_ip: local_ip || null } : { _local_ip: local_ip || null };
    return {
      fingerprint_id: result.visitorId || null,
      is_incognito: null,
      fingerprint_details: btoa(Array.from(new TextEncoder().encode(JSON.stringify(components)), b => String.fromCharCode(b)).join('')),
    };
  } catch {
    return { fingerprint_id: null, is_incognito: null, fingerprint_details: null };
  }
}